import React from 'react';

interface IProps {
  children?: React.ReactNode;
  id?: string;
  label?: string;
  value?: string;
  className?: string;
  ariaHidden?: boolean;
  styles?: any;
}

export const TabPanel = ({
  id,
  className,
  children,
  ariaHidden,
  label = '',
  value = '',
  styles,
}: IProps) => {
  const param = {
    id: id || undefined,
    role: 'tabpanel',
    className,
    'aria-hidden': ariaHidden,
  };
  return (
    <div {...param} style={styles}>
      {children}
    </div>
  );
};
